import { shouldUseMocks } from './mockApi'
import * as mock from './mockApi/medicinesApi'
import { patientGet, patientPost, patientPatch } from './patientApi'

const BASE = '/api/secure/me/medicines'
const CTX = { requirePatientContext: true }

export async function listMedicines(profile, includeArchived = false) {
  if (shouldUseMocks()) return mock.listMedicines(profile, includeArchived)
  const res = await patientGet(BASE, { ...CTX, params: { includeArchived } })
  return res?.data || []
}

export async function todaysDoses(profile) {
  if (shouldUseMocks()) return mock.todaysDoses(profile)
  const res = await patientGet(`${BASE}/today`, CTX)
  return res?.data || []
}

export async function getMedicine(profile, id) {
  if (shouldUseMocks()) return mock.getMedicine(profile, id)
  const res = await patientGet(`${BASE}/${encodeURIComponent(id)}`, CTX)
  return res?.data || null
}

export async function createMedicine(profile, body) {
  if (shouldUseMocks()) return mock.createMedicine(profile, body)
  const res = await patientPost(BASE, body, CTX)
  return res?.data
}

export async function updateMedicine(profile, id, patch) {
  if (shouldUseMocks()) return mock.updateMedicine(profile, id, patch)
  const res = await patientPatch(`${BASE}/${encodeURIComponent(id)}`, patch, CTX)
  return res?.data
}

export async function recordIntake(profile, id, body) {
  if (shouldUseMocks()) return mock.recordIntake(profile, id, body)
  const res = await patientPost(`${BASE}/${encodeURIComponent(id)}/intake`, body, CTX)
  return res?.data
}

export async function intakeHistory(profile, id, from, to) {
  if (shouldUseMocks()) return mock.intakeHistory(profile, id, from, to)
  const res = await patientGet(`${BASE}/${encodeURIComponent(id)}/intake-history`, {
    ...CTX,
    params: { from, to },
  })
  return res?.data || []
}

export async function recordSideEffect(profile, id, body) {
  if (shouldUseMocks()) return mock.recordSideEffect(profile, id, body)
  const res = await patientPost(`${BASE}/${encodeURIComponent(id)}/side-effect`, body, CTX)
  return res?.data
}

export async function listSideEffects(profile, id) {
  if (shouldUseMocks()) return mock.listSideEffects(profile, id)
  // Backend hasn't shipped a list endpoint for side-effects yet; return [] until it does.
  return []
}
